<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            :columnConfig="true"
            :showSequence="false"
            :addButton="{ enabled: false }"
            :deleteButton="{ enabled: false }"
            :tableHeight="screenHeight - 190"
            :updateButton="{ enabled: false }"
            @gotoSurgeryInfo="gotoSurgeryInfo"
            :filterSpan="[17, 5]"
            @loadDocArchiveView="loadDocArchiveView"
            @loadDocumentView="loadDocumentView"
            @selectionChange="loadChecked"
        >
            <slot slot="filter">
                <el-col :md="9" :lg="7" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5" :lg="3" :xl="3">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left">
                        <div class="fg-info ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)`">
                            <el-tag :type="row.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag>
                            <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                            {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)` }}
                        </div>
                        <div style="height: 20px">
                            <span class="ellipsis">{{ row.surgeries }}</span>
                        </div>
                        <div style="height: 20px">
                            <span class="ellipsis">{{ row.diseases }}</span>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <template slot="surgeon_info" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
            </template>
            <template slot="anes_doctor_info" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.anes_doctor && `(主)${row.anes_doctor}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.anes_assistants }}</span>
                </div>
            </template>
        </crud-facecade>
        <el-drawer key="drawer2" :visible.sync="drawerVisible2" :with-header="false" direction="rtl">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="background: white" :style="{ height: `${this.screenHeight}px` }">
                <template v-if="filterDocumentList.length > 0">
                    <div v-for="g in filterDocumentList" :key="g.surgeryId" class="padding10">
                        <div class="align-left font-size12">
                            <span class="el-icon-location fg-primary font-size14" v-if="surgeryId == g.surgeryId"></span>
                            {{ (g.surgery && $moment(g.surgery.apply_time).format('YYYY/MM/DD HH:mm')) || '--' }}
                            <span class="circle fg-red borderd" v-if="g.surgery && g.surgery.is_reoperation">再</span>
                            <br>
                            <span class="fg-info">{{ g.surgery && g.surgery.surgery_status }}</span>
                        </div>
                        <div :key="index" v-for="(item, index) in g.children">
                            <div class="title align-left padding5">
                                <span class="el-icon-document"></span><b>{{ item.label }}</b
                                >&nbsp;&nbsp;({{ item.children.length }})
                            </div>
                            <div class="padding20 padding-none-v">
                                <div v-for="c in item.children" :key="c.index" class="align-left cursor-pointer" @click="loadInstance(c)">
                                    {{ c.label }} &nbsp;&nbsp;<span class="fg-info">{{ c.createby }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <span v-else>暂无记录</span>
            </el-scrollbar>
        </el-drawer>
        <cus-dialog class="document-medicalrecord" :title="document.title" :visible.sync="document.dialogFormVisible" width="60%" :footerVisible="false">
            <DocFrame v-if="document.docno > 0" ref="doc" :docno="document.docno" :docbizid="document.docbizid" :surgeryId="surgeryId"></DocFrame>
            <div v-else style="min-height: 600px" v-loading="loading">
                <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import pdf from '@/common/vue-pdf-4.1.0'
import axios from 'axios'
export default {
    name: `ReOperationsQuery`,
    components: { pdf },
    props: {},
    data() {
        return {
            title: `再次手术查询`,
            buttons: [
                {
                    label: `病案浏览`,
                    type: `primary`,
                    emit: `loadDocumentView`,
                    permission: `default`
                },
                {
                    label: `患者数据`,
                    type: `primary`,
                    emit: `gotoSurgeryInfo`,
                    permission: `default`
                }
            ],
            url: {
                area: `medicalrecord`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.ReloadListData()
                }
            },
            rdate: [this.$moment().format(`YYYY/MM/01`), this.$moment().format(`YYYY/MM/DD 23:59:59`)],
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            documentList: [],
            surgeryId: undefined,
            drawerVisible: false,
            drawerVisible2: false,
            document: {
                title: ``,
                dialogFormVisible: false,
                docno: ``,
                docbizid: ``
            },
            src: undefined,
            numPages: 0,
            loading: false,
            checkedRow: [],
            is_sealed: false,
            ward_id: undefined
        }
    },
    created() {
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
    },
    computed: {
        ...mapGetters([`screenHeight`, `ward_auth`, `operation_ward_auth`, `business`, `currentUser`, `sys_enums`, `screenHeight`, `active_ward`,
            `otherSettingColumn`,
            `extendColumnList`]),
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `360`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`ReOperations.visit_no`),
                    width: `100`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    //   type: "string",
                    //   prop: "blood",
                    //   label: "血型",
                    //   width:"80",
                    //   isListable: true
                    // }, {
                    //   type: "string",
                    //   prop: "height",
                    //   label: "身高",
                    //   width:"60",
                    //   isListable: true
                    // }, {
                    //   type: "string",
                    //   prop: "weight",
                    //   label: "体重",
                    //   width:"60",
                    //   isListable: true
                    // }, {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `80`,
                    isListable: true,
                    searchable: true
                    // sortable: false
                },
                {
                    type: `select`,
                    prop: `enum_surgery_status`,
                    label: `手术状态`,
                    width: `80`,
                    queryable: true,
                    searchable: true,
                    options: this.sys_enums.SurgeryStatus || []
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    width: `80`,
                    queryable: true,
                    searchable: true,
                    options: this.sys_enums.Enum_SurgeryType || []
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `手术开始时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `surgeon_info`,
                    label: `手术医生`,
                    width: `90`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `手术医生`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: `手术助手`,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `anes_doctor_info`,
                    label: `麻醉医生`,
                    width: `90`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: `麻醉医生`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `anes_assistants`,
                    label: `麻醉助手`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `equipment_nurse`,
                    label: `器械护士`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `circuit_nurse`,
                    label: `巡回护士`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true
                }
            ]
            return list
        },
        filterDocumentList() {
            let nd = _.filter(this.documentList, d => d.children && d.children.length > 0)
            let r = _.reduce(
                _.groupBy(nd, `surgeryId`),
                function(result, v, key) {
                    result.push({
                        surgeryId: key,
                        surgery: v[0].surgery,
                        children: v
                    })
                    return result
                },
                []
            )
            return _.orderBy(r, `surgery.apply_time`)
        }
    },
    methods: {
        ReloadListData() {
            // 更改日期触发更新列表
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/Operation/Home/Get`, { begin: that.rdate[0], end: that.rdate[1] })
                req.then(data => {
                    let r = _.filter(data, d => {
                        return (that.dic_operating_ward_id && that.dic_operating_ward_id == d.dic_operating_ward_id) || !this.dic_operating_ward_id
                    }).map(d => {
                        d.is_sealed = !!d.is_sealed
                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        return d
                    })
                    let dt = _.reduce(
                        _.groupBy(r, r => r.biz_surgery_info_id_parent || r.id),
                        function(result, v, index) {
                            if (v.length > 1) {
                                let o = { ..._.find(v, { is_reoperation: false }) }
                                // o.hasChildren = true
                                o.children = _.filter(v, { is_reoperation: true })
                                result.push(o)
                            }
                            return result
                        },
                        []
                    )
                    resolve(dt)
                }).catch(e => reject(e))
            })
        },
        gotoSurgeryInfo({ row }) {
            let r = _.find(this.business, { business_level: `M003`, location: `basic_info` })
            this.$router.push(`${(r && r.url) || `/`}?surgery_id=${row.id}`)
        },
        gotoDocument(document) {
            this.$confirm(`转到患者文书, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let r = _.find(this.business, { business_level: `M004` })
                this.$router.push(`${(r && r.url) || `/`}?surgery_id=${this.surgeryId}&&document_id=${document.docid}`)
            })
        },
        loadDocArchiveView({ row }) {
            this.is_sealed = row.is_sealed
            this.ward_id = row.dic_operating_ward_id ? `ow_${row.dic_operating_ward_id}` : `rw_${row.dic_recovery_ward_id}`
            this.drawerVisible = true
            this.surgeryId = row.id
            this.loadDocumentList([row])
        },
        loadDocumentList(surgeries) {
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: surgeries[0].id }
                })
                let req2 = _.map(surgeries, d => {
                    return this.myaxios.get(`/api/Operation/Home/ArchiveList?surgeryInfoId=${d.id}`)
                })
                let req3 = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                this.myaxios.all(req, req3, ...req2).then(([data, data3, ...data2]) => {
                    this.documentList = _.reduce(
                        data2,
                        function(result, v, index) {
                            if (v.length == 0) return
                            let surgery = _.find(surgeries, { id: v[0].biz_surgery_info_id })
                            let r = [
                                {
                                    surgeryId: v[0].biz_surgery_info_id,
                                    surgery: surgery,
                                    index: `MZYFS`,
                                    hasChildren: true,
                                    children:
                                        _.map(v, d => {
                                            return {
                                                surgeryId: d.biz_surgery_info_id,
                                                index: d.enum_record_type == 1 ? `MZD` : `FSD`,
                                                docno: d.enum_record_type == 1 ? -1 : -2,
                                                label: d.record_type,
                                                archiveddt: d.is_archived ? d.archive_date : ``
                                            }
                                        }) || [],
                                    label: `麻醉与复苏`
                                }
                            ].concat(
                                _.filter(_.orderBy(data.data, `PrintOrder`), d => {
                                    let dc = _.find(data3, d3 => d3.document_id == d.DocNo)
                                    return (
                                        dc &&
                                        _.some(dc.regions, reg => {
                                            return reg.dic_operating_ward_id == v.dic_operating_ward_id || reg.dic_recovery_ward_id == v.dic_recovery_ward_id
                                        })
                                    )
                                }).map(dr => {
                                    let d = { ...dr }
                                    d.surgeryId = v[0].biz_surgery_info_id
                                    d.surgery = surgery
                                    d.index = `${d.DocNo}`
                                    d.hasChildren = d.IsSurportHtml
                                    d.children = []
                                    d.label = d.DocName
                                    return d
                                })
                            )
                            result.push(...r)
                            return result
                        },
                        []
                    )
                    _.forEach(this.documentList, d => {
                        if (d.hasChildren && d.DocNo > 0) {
                            this.loadInstances(d.index, d.surgeryId)
                        }
                    })
                })
            })
        },
        loadInstances(docno, surgeryId) {
            let submenu = _.find(this.documentList, d => {
                return d.DocNo == docno && d.surgeryId == surgeryId
            })
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` },
                params: { docid: docno, dept: `acis2020`, vid: surgeryId }
            })
            req.then(data => {
                submenu.children = _.filter(data.Content, d => {
                    return d.istemplate == `0`
                }).map(d => {
                    d.index = `${d.docbizid}`
                    d.docno = submenu.DocNo
                    d.label = d.docname
                    return d
                })
            })
        },
        loadAssociatedOperations(surgeryInfoId) {
            return this.myaxios.post(`api/Intraoperative/Anaesthesia/AssociatedOperations?surgeryInfoId=${surgeryInfoId}`)
        },
        loadDocumentView({ row }) {
            this.drawerVisible2 = true
            this.ward_id = row.dic_operating_ward_id ? `ow_${row.dic_operating_ward_id}` : `rw_${row.dic_recovery_ward_id}`
            this.surgeryId = row.id
            this.loadAssociatedOperations(row.id).then(surgeries => {
                this.loadDocumentList(surgeries)
            })
        },
        loadInstance(doc) {
            if (doc.docno > 0) {
                this.document = {
                    title: doc.label,
                    docno: doc.docno,
                    docbizid: doc.docbizid,
                    dialogFormVisible: true
                }
                this.src = undefined
                // this.document.dialogFormVisible=true
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else {
                this.loading = true
                let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${doc.index == `MZD` ? 1 : 2}`)
                req.then(data => {
                    this.document = {
                        title: doc.label,
                        docno: doc.docno,
                        docbizid: doc.docbizid,
                        dialogFormVisible: true
                    }
                    // this.document.dialogFormVisible=true
                    this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                    this.src.then(content => {
                        this.numPages = content.numPages
                        this.loading = false
                    })
                }).catch(e => {
                    console.log(e)
                    this.loading = false
                })
            }
        },
        loadChecked({ row }) {
            this.checkedRow = row
        },
        seal() {
            let rows = _.filter(this.checkedRow, d => {
                return !d.is_sealed
            })
            if (rows.length > 0) {
                let reqs = this.myaxios.put(
                    `/api/Operation/Home/Seals`,
                    rows.map(d => d.id)
                )
                reqs.then(() => {
                    this.$refs[`surgery-list`].ReloadListData()
                    this.$message.success(`封存成功`)
                })
            } else {
                this.$message.warning(`未选中未封存病例`)
            }
        },
        unSeal() {
            let rows = _.filter(this.checkedRow, d => {
                return d.is_sealed
            })
            if (rows.length !== this.checkedRow.length) {
                this.$message.warning(`部分患者病案未封存，无法取消封存`)
                return false
            }
            if (rows.length > 0) {
                let reqs = this.myaxios.put(
                    `/api/Operation/Home/UnSeals`,
                    rows.map(d => d.id)
                )
                reqs.then(() => {
                    this.$refs[`surgery-list`].ReloadListData()
                    this.$message.success(`取消封存成功`)
                })
            } else {
                this.$message.warning(`未选中封存病例`)
            }
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        dic_operating_ward_id: function() {
            this.$refs[`surgery-list`].ReloadListData()
        }
    }
}
</script>
<style  lang="less">
.document-medicalrecord .el-dialog__body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Medicalrecord/ReOperationsQuery.vue